import { render, staticRenderFns } from "./MonthGoods.vue?vue&type=template&id=2a659d64&scoped=true"
import script from "./MonthGoods.vue?vue&type=script&lang=js"
export * from "./MonthGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a659d64",
  null
  
)

export default component.exports